import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Box,
  Tabs,
  Tab,
  Alert,
  Snackbar,
} from '@mui/material';
import { AlpacaConfig } from '../../components/broker/AlpacaConfig';
import { TDAmeritradeConfig } from '../../components/broker/TDAmeritradeConfig';
import { CoinbaseConfig } from '../../components/broker/CoinbaseConfig';
import { KrakenConfig } from '../../components/broker/KrakenConfig';
import { BinanceUSConfig } from '../../components/broker/BinanceUSConfig';
import { RobinhoodConfig } from '../../components/broker/RobinhoodConfig';

export const BrokerConfigPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [notification, setNotification] = useState<{
    open: boolean;
    message: string;
  }>({
    open: false,
    message: '',
  });

  const handleConfigSaved = () => {
    // Show a success message that includes information about automatic connection
    setNotification({
      open: true,
      message: 'Configuration saved successfully. Exchange connection will be established automatically!'
    });
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const handleCloseNotification = () => {
    setNotification({
      ...notification,
      open: false
    });
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" gutterBottom>
          Broker Configuration
        </Typography>
        
        <Typography variant="body1" color="textSecondary" paragraph>
          Connect your brokerage accounts to start tracking your portfolio and executing trades.
        </Typography>
        
        <Alert severity="info" sx={{ mb: 3 }}>
          When you save your API configuration, Strategiz will automatically establish a connection 
          to the exchange. Your dashboard and portfolio will be updated with data from this exchange 
          without requiring any additional steps.
        </Alert>

        <Box sx={{ width: '100%' }}>
          <Tabs value={activeTab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" sx={{ mb: 3 }}>
            <Tab label="Stock Brokers" />
            <Tab label="Crypto Exchanges" />
          </Tabs>
          {activeTab === 0 && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <AlpacaConfig onConfigSaved={handleConfigSaved} />
              </Grid>
              <Grid item xs={12} md={6}>
                <TDAmeritradeConfig onConfigSaved={handleConfigSaved} />
              </Grid>
              <Grid item xs={12} md={6}>
                <RobinhoodConfig onConfigSaved={handleConfigSaved} />
              </Grid>
            </Grid>
          )}
          {activeTab === 1 && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <CoinbaseConfig onConfigSaved={handleConfigSaved} />
              </Grid>
              <Grid item xs={12} md={6}>
                <KrakenConfig onConfigSaved={handleConfigSaved} />
              </Grid>
              <Grid item xs={12} md={6}>
                <BinanceUSConfig onConfigSaved={handleConfigSaved} />
              </Grid>
            </Grid>
          )}
        </Box>
        
        <Snackbar
          open={notification.open}
          autoHideDuration={6000}
          onClose={handleCloseNotification}
          message={notification.message}
        />
      </Box>
    </Container>
  );
};
